import type { MilestoneDatesDto, SourcingEventV2PatchDto } from "../../../../../autogen/bff-api";
import type { MilestoneKey } from "./milestones";

export const daysBetween = (anchorIso: string, dateIso: string): number =>
  Math.round((new Date(dateIso).getTime() - new Date(anchorIso).getTime()) / 86_400_000);

export const milestoneOffsetPatch = (
  nodeKey: MilestoneKey,
  pickedIso: string,
  dates: MilestoneDatesDto,
): SourcingEventV2PatchDto | null => {
  switch (nodeKey) {
    case "questionDeadline": {
      if (!dates.bidSubmissionDeadline) return null;
      return {
        eventData: {
          milestonePlan: {
            questionDaysBeforeBid: daysBetween(pickedIso, dates.bidSubmissionDeadline),
          },
        },
      };
    }
    case "bidDeadline": {
      if (!dates.announcement) return null;
      return {
        eventData: {
          bidSubmissionDeadlineConfirmed: true,
          milestonePlan: {
            bidOffsetDays: daysBetween(dates.announcement, pickedIso),
          },
        },
      };
    }
    case "evaluationStart": {
      if (!dates.bidSubmissionDeadline) return null;
      return {
        eventData: {
          milestonePlan: {
            evaluationOffsetDays: daysBetween(dates.bidSubmissionDeadline, pickedIso),
          },
        },
      };
    }
    case "awardDecision": {
      if (!dates.evaluationTarget) return null;
      return {
        eventData: {
          milestonePlan: {
            awardOffsetDays: daysBetween(dates.evaluationTarget, pickedIso),
          },
        },
      };
    }
    case "contractSigning": {
      const anchor = dates.karensDate ?? dates.awardTarget;
      if (!anchor) return null;
      return {
        eventData: {
          milestonePlan: {
            contractSigningOffsetDays: daysBetween(anchor, pickedIso),
          },
        },
      };
    }
    default:
      return null;
  }
};
